import { FC, useEffect, useMemo, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { PaginateModel } from "../../models/PaginateModel";
import * as AbilitiesCRUD from './AbilitiesCRUD';
import { DATA_PAGINATION_LENGTH, PaginationLength } from "../../../_metronic/partials/pagination/PaginationLength";
import { Paginate } from "../../../_metronic/partials/pagination/Paginate";
import { PaginationHeader } from "../../../_metronic/partials/pagination/PaginationHeader";
import { useHistory } from "react-router-dom";
import queryString from 'query-string'
import { formatPrice } from "../../selectors";
import { SearchModel, AbilityModel } from "../../models/AbilityModel";
import AbilitiesTable from "./AbilitiesTable";
import Flatpickr from "react-flatpickr";
import { ABILITIES_PAYMENT_METHOD, ABILITIES_TYPES, DEFAULT_PER_PAGE } from "../../constants/common";
import moment from "moment";
import {GetStoreIfo} from "../../hooks/PermissionChecker";
import { ModalModel } from "../../models/CommonModel";
import ConfigModal from "./ConfigModal";
import _ from "lodash";
import {Vietnamese} from "flatpickr/dist/l10n/vn.js"
import parseParams from "../../selectors/formatParams";
import { download } from "../../modules/common/helper";
export interface ReportModel {
    openning_balance: number
    total_expense: number
    total_revenue: number
    ending_balance: number
}

export interface HeaderModel {
    label: string
    style?: any 
    class?: string 
    field: string,
    sortable?: boolean
}

const Abilities: FC = () => {
    const intl = useIntl();
    const history = useHistory();
    const [dataPaginate, setDataPaginate] = useState<PaginateModel<AbilityModel>>();
    const [hideCols, setHideCols] = useState<string[]>(['note']);
    const storeInfo = GetStoreIfo();
    const fp = useRef<any>(null);
    const searchHistory = history.location.search;
    const initParams: SearchModel = parseParams(queryString.parse(searchHistory))
    const initRange:any = [initParams?.start_date ?? moment().format('YYYY-MM-DD'), initParams?.end_date ?? moment().format('YYYY-MM-DD')]
    const initSearch = {
        page: 1,
        per_page: DEFAULT_PER_PAGE,
        start_date: initRange[0],
        end_date: initRange[1]
    }
    const [configModal, setConfigModal] = useState<ModalModel>({
        show: false,
        mode: 'add',
    });
    const [reportData, setReport] = useState<ReportModel>({
        openning_balance: 0,
        total_expense: 0,
        total_revenue: 0,
        ending_balance: 0
    });
    const [search, setSearch] = useState<SearchModel>(initSearch)
    const header: HeaderModel[] = [
        {
            label: intl.formatMessage({ id: 'ABILITIES.TYPE' }),
            style: { minWidth: "100px" },
            field: 'type',
            sortable: false
        },
        {
            label: intl.formatMessage({ id: 'ABILITIES.DATE' }),
            style:  { minWidth: "150px" },
            field: 'created_at',
            sortable: true
        },
        {
            label: 'Ngày sao kê',
            style:  { minWidth: "150px" },
            field: 'date',
            sortable: true
        },
        {
            label: intl.formatMessage({ id: 'ABILITIES.NAME' }),
            style:  { minWidth: "150px" },
            field: 'name',
            sortable: true
        },
        {
            label: 'Ngân hàng',
            style:  { minWidth: "150px" },
            field: 'bank_id',
            sortable: true
        },
        {
            label: 'Tiền thu',
            style:  { minWidth: "150px", textAlign: 'right'},
            field: 'income',
            sortable: true
        },
        {
            label: 'Tiền chi',
            style:  { minWidth: "150px", textAlign: 'right' },
            field: 'outcome',
            sortable: true
        },
        {
            label: 'Phân loại',
            style:  { minWidth: "150px", textAlign: 'center' },
            field: 'purpose',
            sortable: false
        },
        {
            label: intl.formatMessage({ id: 'ABILITIES.DESCRIPTION' }),
            style:  { minWidth: "250px", textAlign: 'center' },
            field: 'note',
            sortable: true
        }
    ]
    

    useEffect(() => {
		document.title = 'Sento - Sổ quỹ';
	})

    useEffect(() => {
        getData({ ...search, ...initParams });
        getReport({ ...search, ...initParams });
    }, []);

    const getData = async (params?: SearchModel) => {
        let searchQ = {...params};
        if (searchQ?.start_date && searchQ.end_date) {
            searchQ = {...searchQ, date: {startDate: searchQ.start_date, endDate: searchQ.end_date}}
        }
        const { data: resData } = await AbilitiesCRUD.getList(searchQ);
        const objQuery = { ...params }
        if (objQuery.page === 1) {
            delete objQuery.page
        }
        if (objQuery.per_page === DEFAULT_PER_PAGE) {
            delete objQuery.per_page
        }
        history.push({ search: `?${queryString.stringify(objQuery)}` })
        setDataPaginate(resData?.paginate_data);
        setSearch(params ?? {});
    }

    const getReport = async (params?: SearchModel) => {
        let searchQ = {...params};
        if (searchQ?.start_date && searchQ.end_date) {
            searchQ = {...searchQ, date: {startDate: searchQ.start_date, endDate: searchQ.end_date}}
        }
        AbilitiesCRUD.getAbilityReport(searchQ).then(({ data }) => {
            setReport(data);
        })
    }

    const handlePageChange = (data: any) => {
        getData({ ...search, page: data.selected + 1 })
    }

    const handlePageLengthChange = (e: any) => {
        getData({ ...search, page: 1, per_page: +e.target.value })
    }

    const handleSearch = (e: any) => {
        e.preventDefault();
        getData({ ...search, page: 1 })
        getReport({ ...search, page: 1 })
    }

    const handleClearSearch = (e: any) => {
        e.preventDefault();
        setSearch(initSearch);
        if (fp.current?.flatpickr) {
            fp.current.flatpickr.clear();
        }
        getData(initSearch)
    }

    const handleExport = async () => {
        const { data } = await AbilitiesCRUD.exportCsv({ ...search});
        download(data, 'ability');
    }
    
    const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
        const currentSearch = { ...search };
        const sortParams: SearchModel = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
        if (direction === 'none') {
          delete sortParams.sort_by;
          delete sortParams.sort_direction;
        }
        getData({ ...sortParams });
    }

    const handleChangeVisCols = (e: any) => {
        let hiddenCols = [...hideCols];
        if (!e.target?.checked) {
            setHideCols([...hiddenCols, e.target.name])
        } else {
            setHideCols(hiddenCols.filter((item) => item !== e.target.name ))
        }
    }

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            handleSearch(e);
        }
    }
    return <>
        <div className="card">
            <div className="card-header p-3">
                <div className="col-md-12">
                    <form onSubmit={handleSearch}>
                        <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">{intl.formatMessage({ id: 'COMMON.KEYWORD' })}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder=""
                                    name="keyword"
                                    value={search.keyword || ''}
                                    onChange={(e) => setSearch({ ...search, keyword: e.target.value })}
                                    autoComplete='nope'
                                    onKeyDown={(e) => handleKeyDown(e)}
                                />
                            </div>
                            <div className='col-md-3 mb-2'>
                                <label className="form-label">{intl.formatMessage({ id: 'COMMON.TIME' })}</label>
                                <Flatpickr
                                    ref={fp}
                                    onChange={(date) => {
                                        let startDate = moment(date[0]).format('YYYY-MM-DD');
                                        let endDate = moment(date[1]).format('YYYY-MM-DD');
                                        setSearch({ ...search, start_date: startDate, end_date: endDate });
                                    }}
                                    options={{
                                        mode: "range",
                                        dateFormat: 'd-m-Y',
                                        locale: Vietnamese,
                                        enableTime: false,
                                        defaultDate: [moment(initRange[0]).format('DD-MM-YYYY'), moment(initRange[1]).format('DD-MM-YYYY')],
                                    }}
                                    className='form-control'
                                    placeholder=''
                                />
                            </div>
                            <div className="col-md-3 mb-2">
                                <label className="form-label">{intl.formatMessage({ id: 'ABILITIES.TYPE' })}</label>
                                <select className="form-select" value={search?.type ?? ''}
                                    onChange={(e) => setSearch({ ...search, type: e.target.value })}
                                    name="type">
                                    <option value=''>Tất cả</option>
                                    {ABILITIES_TYPES.map((type, key) => <option value={type?.id} key={`a_type_${key}`}>{type?.label}</option>)}
                                </select>
                            </div>
                            <div className="col-md-3 mb-2">
                                <label className="form-label">{intl.formatMessage({ id: 'ABILITIES.PAYMENT_MOTHOD' })}</label>
                                <select className="form-select" value={search?.payment_method ?? ''}
                                    onChange={(e) => {
                                        let newSearch = { ...search, payment_method: e.target.value }
                                        if (e.target.value !== 'banking') {
                                            newSearch = {...newSearch, bank_id: undefined}
                                        }
                                        setSearch({ ...newSearch })
                                    }}
                                    name="payment_method">
                                    <option value="">Tất cả</option>
                                    {ABILITIES_PAYMENT_METHOD.map((payment, key) => <option value={payment?.id} key={`a_payment_${key}`}>{payment?.label}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3 mb-2 mt-2">
                                <label className="form-label">Ngân hàng</label>
                                <select 
                                    className="form-select" 
                                    value={search?.bank_id ?? ''}
                                    onChange={(e) => setSearch({ ...search, bank_id: e.target.value ? parseInt(e.target.value) : undefined })}
                                    name="bank_id">
                                    <option value="">Tất cả</option>
                                    {storeInfo?.banks?.map((bank, key) => <option value={bank?.id} key={`a_bank_${key}`}>{bank?.bank_name} - {bank?.bank_account_number}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-md-4 mb-2 mt-2'>
                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                    <input 
                                        className='form-check-input' 
                                        type='checkbox' 
                                        name='filter_by_date' 
                                        checked={search?.filter_by_date == 1} 
                                        onChange={(e) => setSearch({ ...search, filter_by_date: e.target.checked ? 1 : 0 })}
                                    />
                                    <span className='form-check-label'>Lọc theo ngày sao kê</span>
                                </label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="btns-group">
                                    <button
                                        className="col-auto btn btn-primary mt-2 me-2"
                                        onClick={handleSearch}
                                    >
                                        <i className="bi bi bi-search fs-4"></i> {intl.formatMessage({ id: 'COMMON.SEARCH' })}
                                    </button>
                                    <button
                                        className="col-auto btn btn-danger mt-2 me-2"
                                        type="button"
                                        onClick={handleClearSearch}
                                    >
                                        <i className="bi bi-eraser-fill fs-1"></i> Re-search
                                    </button>
                                    <button className="btn mt-2 btn-icon btn-sm me-2 btn-light-info text-hover-white" type="button"
                                        onClick={handleExport}>
                                        <i className="bi bi-cloud-arrow-down-fill fs-1 text-info" />
                                    </button>
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className="card-body p-3">
                <div className="row  align-items-center mb-5">
                    <div className='col-12 col-md-6 col-lg-3'>
                        <label className="fw-bolder">Số dư đầu kỳ</label><br/>
                        <span className="fs-3">{ formatPrice(reportData?.openning_balance) } VNĐ</span>
                        
                    </div>
                    <div className='col-12 col-md-6 col-lg-3'>
                        <label className="fw-bolder">Tồn cuối kỳ</label><br/>
                        <span className="fs-3">{ formatPrice(reportData?.ending_balance) } VNĐ</span>
                    </div>
                    <div className="col-12 mt-2"></div>
                    <div className='col-12 col-md-6 col-lg-3'>
                        <label className="fw-bolder">Tổng thu</label><br/>
                        <span className="fs-3">{ formatPrice(reportData?.total_revenue) } VNĐ</span>
                    </div>
                    <div className='col-12 col-md-6 col-lg-3'>
                        <label className="fw-bolder">Tổng chi</label><br/>
                        <span className="fs-3">{ formatPrice(reportData?.total_expense) } VNĐ</span>
                    </div>
                    <div className='col-12 col-md-6 col-lg-3'>
                        <label className="fw-bolder">Tổng tiền còn lại</label><br/>
                        <span className="fs-3">{ formatPrice(reportData?.total_revenue - reportData?.total_expense) } VNĐ</span>
                    </div>
                </div>
                <hr/>
                <div className="row justify-content-between align-items-center mb-3">
                    <div className='col-7 col-md-9'>
                        <PaginationHeader from={dataPaginate?.meta?.from || 0} to={dataPaginate?.meta?.to || 0}
                            total={dataPaginate?.meta?.total || 0} />
                    </div>
                </div>
                <AbilitiesTable
                    data={dataPaginate?.data || []}
                    header={header}
                    handleSort={handleSort}
                    openColConfig={() => setConfigModal({...configModal, show: true})}
                    hideCols={hideCols}
                />
            </div>
            <div className="card-footer d-flex justify-content-between paginate-wrapper">
                <PaginationLength selected={search.per_page || DEFAULT_PER_PAGE} onChange={handlePageLengthChange} />
                <Paginate
                    pageCount={dataPaginate?.meta?.last_page || 0}
                    onPageChange={handlePageChange}
                    forcePage={(search.page || 1) - 1}
                />
            </div>
        </div>
        <ConfigModal
            {...configModal}
            header={header}
            hideCols={hideCols}
            handleChangeVisCols={handleChangeVisCols}
            onClose={() => { setConfigModal({ ...configModal, show: false }) }}
        />
    </>
}
export default Abilities;